export default "__VITE_ASSET__DmTdssHN__"